<div class="inquiries-container">
  <div class="inq-tabs">
    <dk-tabs [selectableTabs]="inquiriesTabs" [currentTab]="selectedTab" (tabChange)="changeTab($event)"> </dk-tabs>
  </div>
  <div class="inquiries-header">
    <span class="title">
      {{ 'doktar_app.communications.home.subtitle_hi' | translate: { arg1: userFirstName } }}
    </span>
    <span class="subtitle">
      {{ 'doktar_app.communications.home.subtitle' | translate }}
    </span>
  </div>
</div>
<div class="inquiries-messages">
  <div class="desc-section">
    <span class="description">
      {{ 'doktar_app.communications.home.get_tech_support_desc' | translate }}
    </span>
  </div>
  <div class="inquiries-list">
    <div class="new-chat-box">
      <dk-button
        size="xlarge"
        [icon]="'ph ph-plus'"
        [label]="'doktar_app.communications.new_chat' | translate"
        severity="secondary"
        (click)="createInquiry()"></dk-button>
    </div>

    @if (!loadingInquiries) {
      @for (inquiry of allInquiries; track inquiry.id) {
        <div
          class="inquiries-item"
          [ngClass]="{ selected: inquiry.id === selectedInquiryId }"
          (click)="selectInquiry(inquiry.id)">
          <div class="inquiries-item-card">
            <div class="thumbnail">
              <p-avatar [style]="{ height: '48px', width: '48px' }" [shape]="'circle'">
                @if(inquiry.inquiryCorrespondences[0]?.correspondenceType == 'AI'){
                  <dk-seed-icon-native></dk-seed-icon-native>
                } @else {
                  <dk-generic-seed-icon></dk-generic-seed-icon>
                }
              </p-avatar>
            </div>
            <div class="content">
              <div class="title">
                {{ inquiry.platform + ' • ' + (inquiry.updatedAt | utcToLocal: inquiryDateFormat) }}
              </div>
              @if(inquiry.inquiryCorrespondences[0]?.correspondenceType == 'AI'){
                <div class="description" [innerHTML]="renderedContents[inquiry.inquiryCorrespondences[0]?.id]"></div>
              } @else {
                <div class="description">
                  {{ inquiry.inquiryCorrespondences[0]?.inquiryContent }}
                </div>
              } 
              <div class="date">
                {{ formatMessageDate(inquiry.inquiryCorrespondences[0]?.createdAt) }}
              </div>
            </div>
          </div>
          <div class="inquiries-item-footer">
            <span class="land-name">
              {{ inquiry.inventoryName }}
            </span>
            @if (inquiry.id === selectedInquiryId) {
              <dk-button
                #menuButton
                size="medium"
                [icon]="'ph ph-dots-three'"
                severity="secondary"
                [text]="true"
                [disabled]="loadingDelete"
                (click)="openDialogForDeleteChat($event, inquiry.id)"></dk-button>
            }
          </div>
        </div>
      }
    } @else {
      <!-- Show skeleton loading while keeping the list structure -->
      @for (item of [1, 2, 3]; track item) {
        <div class="inquiries-item skeleton-item">
          <div class="inquiries-item-card">
            <div class="thumbnail">
              <dk-skeleton
                [skeletonConfig]="{
                  size: 1,
                  layout: 'horizontal',
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                }"></dk-skeleton>
            </div>
            <div class="content">
              <div class="title">
                <dk-skeleton
                  [skeletonConfig]="{
                    size: 1,
                    layout: 'horizontal',
                    width: '70%',
                    height: '16px',
                  }"></dk-skeleton>
              </div>
              <div class="description">
                <dk-skeleton
                  [skeletonConfig]="{
                    size: 2,
                    layout: 'vertical',
                    width: '100%',
                    height: '14px',
                  }"></dk-skeleton>
              </div>
              <div class="date">
                <dk-skeleton
                  [skeletonConfig]="{
                    size: 1,
                    layout: 'horizontal',
                    width: '40%',
                    height: '12px',
                  }"></dk-skeleton>
              </div>
            </div>
          </div>
          <div class="inquiries-item-footer">
            <dk-skeleton
              [skeletonConfig]="{
                size: 1,
                layout: 'horizontal',
                width: '60px',
                height: '12px',
              }"></dk-skeleton>
          </div>
        </div>
      }
    }
  </div>
</div>
<p-popover [appendTo]="'body'" #deleteChatPopover>
  <dk-button
    [label]="'doktar_app.support.delete_chat' | translate"
    severity="danger"
    size="large"
    [text]="true"
    [loading]="loadingDelete"
    (onClick)="deleteChat()"></dk-button>
</p-popover>
